import React, { createContext, useContext, useEffect, useState } from "react";

const SidebarCtx = createContext({ collapsed: false, toggle: () => {} });

export function SidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem("hah_sidebar_collapsed") === "1"; } catch { return false; }
  });
  useEffect(() => {
    try { localStorage.setItem("hah_sidebar_collapsed", collapsed ? "1" : "0"); } catch (_e) { /* ignore */ }
  }, [collapsed]);
  return (
    <SidebarCtx.Provider value={{ collapsed, toggle: () => setCollapsed((v) => !v) }}>
      {children}
    </SidebarCtx.Provider>
  );
}

export const useSidebar = () => useContext(SidebarCtx);
